export const schedule = {
  go: {
    start: "Démarrer",
    cantNow: "Impossible maintenant",
    details: "Détails",
  },
notFound: "Planification introuvable",
loadError: {
title: "Impossible de charger cette planification",
description: "Vérifiez votre connexion et réessayez.",
},
startFailed: "Impossible de démarrer cette inspection.",
starting: "Démarrage...",
loadingAsset: "Chargement de l'actif…",
breadcrumb: {
backToRequest: "← Retour à la demande",
scheduledInspection: "Inspection planifiée",
},
calendarInvite: {
titleWithAsset: "Inspection : {{asset}}",
titleFallbackAsset: "Actif",
descriptionChecklist: "Liste de contrôle : {{name}}",
addToCalendar: "Ajouter au calendrier",
notNow: "Plus tard",
confirmedTitle: "Date confirmée",
confirmedBody: "L'équipe a été informée. Ajouter la visite à votre calendrier ?",
},
sourceRequest: {
title: "Depuis la demande",
fallback: "Cette inspection planifiée reste liée à la chronologie de la demande source.",
openRequest: "Ouvrir la demande",
},
visit: {
label: "Visite",
confirmed: "Confirmé par contact",
awaitingConfirmation: "En attente de confirmation de contact",
},
readOnlyAssetNotice: "Cet actif est partagé avec vous en lecture seule, de sorte qu'une inspection ne peut pas être lancée sur celui-ci. Demandez à son propriétaire un accès en modification ou exécutez cette inspection à partir d'un actif dans votre propre espace de travail.",
reschedule: {
accessibilityLabel: "Reprogrammer l'inspection",
label: "Reprogrammer",
},
changeRequest: {
sent: "Demande envoyée",
savedOffline: "Enregistré sur cet appareil — envoi dès que vous serez de nouveau en ligne",
sendFailed: "Impossible d'envoyer la demande",
decideFailed: "Impossible d'enregistrer la décision",
photosNeedSignal: "Les photos ont besoin de signal pour être envoyées. Retirez-les pour enregistrer cette demande hors ligne, ou réessayez une fois de nouveau en ligne.",
},
overflow: {
moreActionsLabel: "Plus d'actions de planification",
sheetTitle: "Options de planification",
},
status: {
  skipped: "Ignorée",
upcoming: "À venir",
due: "Échéance maintenant",
overdue: "En retard",
completed: "Terminé",
cancelled: "Annulé",
},
alerts: {
errorTitle: "Erreur",
templateMissing: "Check-list de liste de contrôle introuvable.",
cancelTitle: "Annuler la planification",
cancelMessage: "Voulez-vous vraiment annuler cette inspection planifiée ?",
cancelConfirm: "Annuler la planification",
no: "Non",
deleteTitle: "Supprimer la planification",
deleteMessage: "Cette planification sera définitivement supprimée.",
deleteConfirm: "Supprimer",
},
labels: {
asset: "Actif",
checklist: "Liste de contrôle",
assignedTo: "Attribué à",
unassigned: "Non attribué",
recurrence: "Répétition",
reminders: "Rappels",
none: "Aucun",
seriesEndDate: "Fin de série (date)",
seriesEndTime: "Fin de série (heure)",
maxCompletedRuns: "S'arrête après",
},
seriesEnd: {
sectionTitle: "Limites de série (facultatif)",
helper: "Laisser vide pour aucune limite. La série s’arrête dès qu’une limite est atteinte.",
maxPlaceholder: "ex. 12",
errors: {
maxPositive: "Entrez un entier ≥ 1 ou laissez vide.",
invalidEnd: "Date ou heure de fin invalide.",
endBeforeStart: "La fin de série doit être égale ou postérieure au début prévu.",
},
},
detail: {
  stopRepeat: {
    failed: "Impossible d'arrêter la répétition. Vérifiez votre connexion et réessayez.",
    done: "Cette inspection ne se répète plus.",
    confirm: "Arrêter la répétition",
    message: "Cette visite est conservée. Aucune autre visite ne sera créée ensuite.",
    title: "Arrêter de répéter cette inspection ?",
    action: "Arrêter la répétition",
  },
seriesEnds: "Fin de la répétition",
maxRuns_one: "S'arrête après {{count}} visite",
maxRuns_many: "S'arrête après {{count}} visites",
maxRuns_other: "S'arrête après {{count}} visites",
unlimitedRuns: "Sans limite",
noEndDate: "Pas de date de fin",
},
list: {
untilDate: "Jusqu’au {{date}}",
maxRunsChip_one: "Jusqu'à {{count}} visite",
maxRunsChip_many: "Jusqu'à {{count}} visites",
maxRunsChip_other: "Jusqu'à {{count}} visites",
typeInspection: "Inspection",
typeJob: "Intervention",
filterActive: "Actif",
filterPast: "Passé",
filterAll: "Tout",
overdueChip: "En retard",
scheduleWork: "Planifier du travail",
scheduleSheetTitle: "Que souhaitez-vous planifier ?",
emptyTitle: "Rien de planifié",
emptyActiveSubtitle: "Planifiez une inspection ou une intervention : elle apparaîtra ici.",
emptyPastSubtitle: "Aucune tâche planifiée passée.",
emptyAllSubtitle: "Aucune tâche planifiée pour le moment.",
},
unknownAsset: "Actif inconnu",
unknownChecklist: "Liste de contrôle inconnue",
templateMeta_one: "{{count}} élément · {{category}}",
templateMeta_other: "{{count}} éléments · {{category}}",
recurrence: {
none: "Ponctuel",
hourly: "Toutes les heures",
daily: "Tous les jours",
weekly: "Toutes les semaines",
biweekly: "Toutes les 2 semaines",
monthly: "Tous les mois",
quarterly: "Tous les 3 mois",
yearly: "Tous les ans",
},
reminder: {
at_time: "À l'heure prévue",
"15min": "15 minutes avant",
"30min": "30 minutes avant",
"1hr": "1 heure avant",
"2hr": "2 heures avant",
"1day": "1 jour avant",
"2day": "2 jours avant",
},
actions: {
startNow: "Démarrer l'inspection",
startFor: "Démarrer pour {{name}}",
cancelSchedule: "Annuler la planification",
viewInspection: "Voir l'inspection",
delete: "Supprimer",
},
planner: {
subtitle: "Choisissez une date, assignez une personne et validez.",
scheduleCta: "Planifier",
scheduleInspection: "Planifier une inspection",
scheduleJob: "Planifier une intervention",
},
create: {
createChecklistCta: "Créer une liste de contrôle",
noChecklistsHint: "Pas encore de liste de contrôle. Créez-en une pour poursuivre la planification.",
overlayReturnFootnote: "S’ouvre en superposition. Après enregistrement, vous revenez ici avec la liste de contrôle sélectionnée.",
ctaAccessibility: "Créer une liste de contrôle et revenir à la planification",
},
templateMeta_many: "{{count}} éléments · {{category}}",
};
